import { authAPI } from '@/providers/apis/auth/auth';
import { shareableLinkAPI } from '@/providers/apis/shareable-link/shareable-link';
import { appConfigService } from '@/providers/services/app/app-config';
import { sessionService } from '@/providers/services/auth/session';
import router from '@/routers/router';
import {Vue, Component, Watch } from 'vue-property-decorator';
import PageNotFound from '../page-not-found/page-not-found';
import { Events } from '@/events';

@Component({
    name: 'shareable-link',
    components: {
        'page-not-found': PageNotFound,
    },
})

export default class ShareableLink extends Vue {

    // ----------------------------------------------------------
    // Properties

    private isLoaded: boolean = false;

    private isInvalidRoute: boolean = false;

    // ----------------------------------------------------------
    // Hooks

    public mounted() {
        this.verifyShareableLink();
        Events.$on('onLoadedConfig', () => {
            this.verifyShareableLink();
        });
    }

    public beforeDestroy() {
        Events.$off('onLoadedConfig');
    }


    // ----------------------------------------------------------
    // Actions


    // ----------------------------------------------------------
    // Methods

    private async verifyShareableLink() {
        const queryParams = this.$route.query;
        const adminUsers = appConfigService.getShareableAdminUserDetail();
        const params = {
            userId: queryParams.userId,
            appName: 'library',
            secretKey: queryParams.secretKey,
            redirectUrl: queryParams.redirectUrl,
        };
        if (adminUsers) {
            authAPI.logInWithCredential(adminUsers.username, adminUsers.password, '').then((sessionModel) => {
                shareableLinkAPI.linkVerification(sessionModel.access_token, params).then((isValid) => {
                    if (isValid) {
                    authAPI.impersonateUser(params.userId as string, sessionModel.access_token).then((userSession) => {
                        userSession.isShareableLink = true;
                        const routeURL = new URL(params.redirectUrl as string);
                        userSession.accessPath = routeURL.pathname;
                        sessionService.setSession(userSession);
                        const routeResolved = router.resolve(params.redirectUrl as string);
                        if (routeResolved.route.name !== '404') {
                            window.location.href = params.redirectUrl as string;
                        } else {
                            this.$router.push('/catalog');
                            this.isLoaded = true;
                        }
                    });
                    } else {
                        this.isLoaded = true;
                    }
                });
            });
        }
    }
}
